import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface OrbitNode {
  symbol: string;
  label: string;
  left: string;
  top: string;
  hideOnMobile?: boolean;
}

// Kept in the upper ~50% so no symbol sits behind the chart card below.
const NODES: OrbitNode[] = [{
  symbol: '₮',
  label: 'USDT',
  left: '7%',
  top: '46%',
  hideOnMobile: true
}, {
  symbol: 'Au',
  label: 'XAU',
  left: '19%',
  top: '26%'
}, {
  symbol: '₿',
  label: 'BTC',
  left: '31%',
  top: '42%'
}, {
  symbol: '¥',
  label: 'JPY',
  left: '38%',
  top: '4%'
}, {
  symbol: '$',
  label: 'USD',
  left: '52%',
  top: '22%'
}, {
  symbol: '£',
  label: 'GBP',
  left: '66%',
  top: '36%'
}, {
  symbol: 'Ξ',
  label: 'ETH',
  left: '79%',
  top: '10%'
}, {
  symbol: '€',
  label: 'EUR',
  left: '92%',
  top: '44%',
  hideOnMobile: true
}];
const RINGS = ['w-[150%]', 'w-[118%]', 'w-[88%]', 'w-[60%]'];

/** Decorative orbit of market symbols around a dotted globe. */
export function HeroOrbit() {
  const reduced = useReducedMotion();
  return <div aria-hidden="true" className="pointer-events-none relative mx-auto h-[200px] w-full max-w-5xl sm:h-[260px]" data-id="element-132" data-mp="329s96ievfapw">
      {RINGS.map(w => <span key={w} className={`absolute left-1/2 top-0 aspect-square -translate-x-1/2 rounded-full border border-white/[0.09] ${w}`} data-id="element-133" data-mp="3783i8qxcdh72" />)}

      <span className="absolute left-1/2 top-[30%] aspect-square w-[46%] -translate-x-1/2 rounded-full opacity-70 [background-image:radial-gradient(rgba(147,170,255,0.9)_1px,transparent_1.4px)] [background-size:11px_11px] [mask-image:radial-gradient(circle,black_25%,transparent_68%)]" data-id="element-134" data-mp="2xi0im7vpt4zr" />

      {NODES.map((node, i) => <motion.span key={node.label} className={`absolute flex -translate-x-1/2 flex-col items-center gap-1.5 ${node.hideOnMobile ? 'hidden sm:flex' : ''}`} style={{
      left: node.left,
      top: node.top
    }} initial={reduced ? undefined : {
      opacity: 0,
      scale: 0.96,
      y: 8
    }} animate={reduced ? undefined : {
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.25 + i * 0.045,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-135" data-mp="2ajx67iy3bmir" data-mpi={i}>
          <span className="grid h-10 w-10 place-items-center rounded-full border border-white/15 bg-brand-950/90 text-[15px] font-semibold text-white shadow-[0_10px_24px_-10px_rgba(0,0,0,0.8)] sm:h-12 sm:w-12 sm:text-[17px]" data-id="element-136" data-mp="1gp3m3ab0lu43">
            {node.symbol}
          </span>
          <span className="text-[9px] font-semibold tracking-[0.16em] text-white/45" data-id="element-137" data-mp="24exxrojllcmr">
            {node.label}
          </span>
        </motion.span>)}
    </div>;
}